import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataService } from '../../../../data.service';
import { GeneralService } from '../../../../general.service';
import {TranslateService} from '@ngx-translate/core';
import Recorder from 'recorder-js';
import { Subscription } from 'rxjs';
import { WebMediaRecorder } from 'src/assets/pages/js/WebMediaRecorder/WebMediaRecorder';
import { } from 'audio-recorder-polyfill';

declare function initSliders(): any


@Component({
  selector: 'app-carrouseloral',
  templateUrl: './carrouseloral.html',
  styleUrls: ['./carrouseloral.scss',
    '../../../../../assets/pages/css/font-awesome.min.css']
})

export class CarrouselOral implements OnInit, OnDestroy {

  public timer;
  public totalSeconds = 0;
  public webMediaRecorder;

  public showDecimalInput = false;
  public isTouchDevice = false;
  public isInTask = false;
  public context = "";
  public supplementary = "";  
  public questionId = 0;
  public allClosed = true;
  public ckString : string = '';
  public blobFile = null;
  
  public shownElements:string[] = [];
  public labels: { [name: string]: string } = {};

  private loadAnswersSubscription : Subscription;
  
  
  
  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    var exisitingLangauge = localStorage.getItem("userslanguage");
    if(exisitingLangauge !== null && exisitingLangauge !== undefined && exisitingLangauge !== ""){
      this.dataSvc.changeLangauge(exisitingLangauge);
    }
    else{
      this.translate.setDefaultLang("en");
      this.translate.use("en");
    }
    initSliders();

    this.loadAnswersSubscription = this.dataSvc.getLoadCarrouselOralAnswersEvent().subscribe(()=>{
      this.loadAnswers();
    });
  }

  ngOnInit(): void {
    this.loadAnswers();
  }

  loadAnswers() {1    
    if(this.dataSvc.currentQuestion().Question.QuestionType !== 1027) return;

    //GET METADATA OF CARROUSEL QUESTION
    //BASED ON CREATION USES SPLITS TO GET THE DATA IN THE FORMAT THAT IT NEEDS
    //SHOW HIDE BASED ON THE NUMBER OF SLIDES RETURNED FROM METADATA
    var carrouselQuestion = this.dataSvc.currentQuestion().Question;
    if(carrouselQuestion !== null && carrouselQuestion !== undefined){
      var carrouselData = carrouselQuestion.Question.Metadata.toString();
      if(carrouselData !== null && carrouselData !== undefined && carrouselData !== ""){
        var allTabs = carrouselData.split("***");
        for(var i = 1; i < allTabs.length; i++){
          if(allTabs[i] !== null && allTabs[i] !== undefined && allTabs[i] !== ""){
            this.shownElements.push("indicator" + i);
            this.shownElements.push("carText" + i);

            var tab = allTabs[i].toString();
            this.labels['label' + i] = tab;
          }
        }
      }
    }
    
    return;
    this.webMediaRecorder = new WebMediaRecorder({
      sessionId: this.dataSvc.currentExam().Session.SessionId,
      questionId: this.dataSvc.currentQuestion().SessionQuestion.QuestionId,
      mock: this.dataSvc.currentExam().Session.IsTest,
      timeslice: 60000,
      rootPath: 'assets/pages/js/WebMediaRecorder/',
      serviceUrl: this.dataSvc.webApiUrl + '/Media/',
      downloadMethod: 'GetAudioURL',
      uploadMethod: 'UpsertSegmentedAudio'
    });

    if (this.dataSvc.currentQuestion().Result.Selection === "Answered") {
      this.webMediaRecorder.loadAudio((_successful, _errType, duration) => {
        if (_successful) {
          this.setCurrentTime(parseInt((duration).toFixed(0)));
          document.getElementById('btn-play-recording').removeAttribute('disabled');
        } else {
          this.setCurrentTime(0);
          document.getElementById('btn-play-recording').setAttribute('disabled', 'true');
          document.getElementById('lbl-audio-result').innerText =  (localStorage.getItem("userslanguage") == "nl" ? 'Er is een fout opgetreden tijdens het opslaan: ' : 'An error has ocurred while saving: ') + _errType;
          document.getElementById('lbl-audio-result').setAttribute('style', 'color:red');
        }
      });
    } else {
      this.setCurrentTime(0);
      document.getElementById('btn-start-recording').removeAttribute('disabled');
      document.getElementById('btn-stop-recording').setAttribute('disabled', 'true');
      document.getElementById('btn-play-recording').setAttribute('disabled', 'true');
    }
  }

  ngOnDestroy(): void {
    if (this.webMediaRecorder !== undefined && this.webMediaRecorder) {
      if (this.webMediaRecorder.isRecording || this.webMediaRecorder.isPlaying) {
        this.stopRecording();
      }
    }
  }

  private setCurrentTime(duration) {
    this.totalSeconds = duration;
    document.getElementById("audio-seconds").innerHTML = this.pad(this.totalSeconds % 60);
    document.getElementById("audio-minutes").innerHTML = this.pad(parseInt((this.totalSeconds / 60).toString()));
  }

  private setTime(self: CarrouselOral) {
    ++self.totalSeconds;

    if (self.totalSeconds >= 1200) {
      self.stopRecording();
    }
    document.getElementById("audio-seconds").innerHTML = self.pad(self.totalSeconds % 60);
    document.getElementById("audio-minutes").innerHTML = self.pad(parseInt((self.totalSeconds / 60).toString()));
  }

  private pad(val) {
    var valString = val + "";
    if (valString.length < 2) {
      return "0" + valString;
    } else {
      return valString;
    }
  }

  startRecording() {
    return;
    var self = this;
    if (this.webMediaRecorder === undefined) {
      this.webMediaRecorder = new WebMediaRecorder({
        sessionId: this.dataSvc.currentExam().Session.SessionId,
        questionId: this.dataSvc.currentQuestion().SessionQuestion.QuestionId,
        mock: this.dataSvc.currentExam().Session.IsTest,
        timeslice: 60000,
        rootPath: 'assets/pages/js/WebMediaRecorder/',
        serviceUrl: this.dataSvc.webApiUrl + '/Media/',
        downloadMethod: 'GetAudioURL',
        uploadMethod: 'UpsertSegmentedAudio'
      });
    }

    document.getElementById('lbl-audio-result').innerText = "";
    document.getElementById('lbl-audio-result').setAttribute("style", "display:none; visibility:hidden");

    this.webMediaRecorder.startRecording(function () {
      document.getElementById('btn-stop-recording').removeAttribute('disabled');
      document.getElementById('btn-start-recording').setAttribute('disabled', 'true');
      document.getElementById('btn-play-recording').setAttribute('disabled', 'true');

      document.querySelectorAll('.exam-question-page').forEach((el) => {
        el.setAttribute('disabled', 'true');
        el.firstElementChild.setAttribute('disabled', 'true');
      });

      self.totalSeconds = 0;
      document.getElementById("audio-seconds").innerHTML = "00";
      document.getElementById("audio-minutes").innerHTML = "00";
      self.timer = setInterval(() => { self.setTime(self); }, 1000);
    });
  }

  stopRecording() {
    return;
    if (this.webMediaRecorder.isRecording) {
      document.getElementById('btn-start-recording').setAttribute('disabled', 'true');
      document.getElementById('btn-stop-recording').setAttribute('disabled', 'true');
      document.getElementById('btn-play-recording').setAttribute('disabled', 'true');

      document.getElementById('lbl-audio-saving').innerText = localStorage.getItem("userslanguage") == "nl" ? 'Opname opslaan: even geduld a.u.b.' : 'Saving recording: please wait';
      document.getElementById('lbl-audio-saving').setAttribute('style', '');
      document.getElementById('lbl-audio-result').innerText = "";
      document.getElementById('lbl-audio-result').setAttribute('style', 'display:none;visibility:hidden');

      var self = this;
      this.webMediaRecorder.stopRecording(function (successful, errType) {
        document.getElementById('btn-start-recording').removeAttribute('disabled');
        document.getElementById('btn-stop-recording').setAttribute('disabled', 'true');

        document.getElementById('lbl-audio-saving').setAttribute('style', 'display:none;visibility:hidden');
        document.getElementById('lbl-audio-result').innerText = (successful ? (localStorage.getItem("userslanguage") == "nl" ? 'Opname opgeslagen' : 'Recording saved')
          : (localStorage.getItem("userslanguage") == "nl" ? 'Er is een fout opgetreden tijdens het opslaan: ' : 'An error has ocurred while saving: ') + errType);
        document.getElementById('lbl-audio-result').setAttribute('style', (successful ? 'color:green' : 'color:red'));

        if (successful) {
          self.dataSvc.currentQuestion().Result.Selection = "Answered";
          self.webMediaRecorder.loadAudio((_successful, _errType, duration) => {
            if (_successful) {
              self.setCurrentTime(parseInt((duration).toFixed(0)));
              document.getElementById('btn-play-recording').removeAttribute('disabled');
              self.dataSvc.currentQuestion().Result.Selection = "Answered";
            } else {
              self.setCurrentTime(0);
              document.getElementById('btn-play-recording').setAttribute('disabled', 'true');
              document.getElementById('lbl-audio-result').innerText =  (localStorage.getItem("userslanguage") == "nl" ? 'Er is een fout opgetreden tijdens het opslaan: ' : 'An error has ocurred while saving: ') + _errType;
              document.getElementById('lbl-audio-result').setAttribute('style', 'color:red');
            }
          });
        } else {
          self.setCurrentTime(0);
        }
      });
      clearInterval(this.timer);

      document.querySelectorAll('.exam-question-page').forEach((el) => {
        el.removeAttribute('disabled');
        el.firstElementChild.removeAttribute('disabled');
      });
    } else {
      this.webMediaRecorder.stop(() => {
        document.getElementById('btn-start-recording').removeAttribute('disabled');
        document.getElementById('btn-stop-recording').setAttribute('disabled', 'true');
        document.getElementById('btn-play-recording').removeAttribute('disabled');
      });
    }
  }

  playRecording() {
    return;
    document.getElementById('btn-start-recording').setAttribute('disabled', 'true');
    document.getElementById('btn-stop-recording').removeAttribute('disabled');
    document.getElementById('btn-play-recording').setAttribute('disabled', 'true');

    this.webMediaRecorder.play(function () {
      document.getElementById('btn-start-recording').removeAttribute('disabled');
      document.getElementById('btn-stop-recording').setAttribute('disabled', 'true');
      document.getElementById('btn-play-recording').removeAttribute('disabled');
    });
  }

 
}
